<div
  class="uni-table-filter-wrapper"
  [class.uni-table-filter-wrapper--right]="alignRight"
  #wrapper
>
  <ng-content></ng-content>
</div>
